import { Button, Stack } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import RestrictedView from '../auth/RestrictedView'
import { i18n } from '../index'

type Props = {
  /** Router path to the settings page where these check questions are edited. */
  to: string
}

/**
 * "Muokkaa" link shown under a checklist section. Navigates managers to the
 * station settings page where the inspection questions for that check are
 * edited. Only visible to users with the manage_ownStation permission.
 *
 * The destination differs per check type (hourly checks vs. WC checks have
 * separate settings pages), so the target is passed in via `to`.
 */
export default function EditChecklistQuestionsLink({ to }: Props) {
  return (
    <RestrictedView requiredPermission='manage_ownStation'>
      <Stack direction='row' justifyContent='flex-end' sx={{ mb: 2.5 }}>
        <Button component={Link} to={to} variant='contained' color='primary'>
          {i18n.t('admin.checkQuestions.editQuestions')}
        </Button>
      </Stack>
    </RestrictedView>
  )
}
